import Card from '@zenbusiness/zui/Card';
import MuiIconButton from '@zenbusiness/zui/IconButton';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import { styled } from '@zenbusiness/zui/styles';

export const Root = styled(Card)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  width: '100%',
  height: '100%',

  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
  },
}));

export const Image = styled(SharedAsset)(({ theme }) => ({
  [theme.breakpoints.up('sm')]: {
    width: '22.5rem',
  },

  [theme.breakpoints.up('lg')]: {
    width: '26.25rem',
  },
}));

export const IconButton = styled(MuiIconButton)(({ theme }) => ({
  position: 'absolute',
  top: theme.spacing(1),
  right: theme.spacing(1),
}));
